import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core';
import { IList } from 'annotation-tools/utils';
import React, { FC, memo, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import { IProjectSummaryType } from '../../../types/record/project-summary';
import { CountResult } from '../../shared/count-result';

const vt = viewTexts.dialogs.approveProject;

const MessageTop = styled.div`
  padding: 5px;
`;

const MessageBottom = styled.div`
  padding: 5px;
`;

const CountResultWrapper = styled.div`
  padding: 10px;
  display: flex;
`;

const CountResultShrinkWrapper = styled.div`
  flex: 0 1 300px;
`;

interface Props {
  projectName: string;
  projectSummary: IList<IProjectSummaryType>;
  open: boolean;
  onClose: (yn: 'yes' | 'no') => void;
}

export const ConfirmProjectResultDialog: FC<Props> = memo(
  ({ projectName, projectSummary, open, onClose }: Readonly<Props>) => {
    const cancelClicked = useCallback(() => {
      onClose('no');
    }, [onClose]);

    const okClicked = useCallback(() => {
      onClose('yes');
    }, [onClose]);

    const onCloseDefault = cancelClicked;

    const message = useMemo<string[]>(() => vt.messageTop(projectName), [
      projectName
    ]);

    return (
      <Dialog onClose={onCloseDefault} open={open}>
        <DialogTitle>{vt.title}</DialogTitle>
        <DialogContent>
          <MessageTop>
            {message.map((msg, idx) => (
              <Typography key={idx}>{msg}</Typography>
            ))}
          </MessageTop>
          <CountResultWrapper>
            <CountResultShrinkWrapper>
              <CountResult projectSummary={projectSummary} />
            </CountResultShrinkWrapper>
          </CountResultWrapper>
          <MessageBottom>
            {vt.messageBottom.map((msg, idx) => (
              <Typography key={idx}>{msg}</Typography>
            ))}
          </MessageBottom>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelClicked} color='default'>
            {vt.buttons.cancel}
          </Button>
          <Button onClick={okClicked} color='primary'>
            {vt.buttons.ok}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

ConfirmProjectResultDialog.displayName = 'ConfirmProjectResultDialog';
